// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.separator-module_separatorBlock__lKzhM {
    --separator-marker: 1;
}

.separator-module_separatorVariantSubheader__y0j50 {
    --separator-marker: 1;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Separator/separator.module.css"],"names":[],"mappings":";AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":["\n.separatorBlock {\n    --separator-marker: 1;\n}\n\n.separatorVariantSubheader {\n    --separator-marker: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"separatorBlock": `separator-module_separatorBlock__lKzhM`,
	"separatorVariantSubheader": `separator-module_separatorVariantSubheader__y0j50`
};
export default ___CSS_LOADER_EXPORT___;
